<template>
  <div class="ac-card-content">
    <div class="ac-body-container">
      <img
        src="@shared/assets/img/logo/smart-maintenance-grey.png"
        class="ac-logo"
        alt="Smart Maintenance®"
      />
      <div class="ac-header">Smart Maintenance® Plan Details</div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img src="@shared/assets/img/setting/benefit-icon.svg" alt="Comfort Credits" />
          Plan Benefits
        </div>
        <div class="ac-plan-body margin-bottom-12">
          SmartAC.com provides a few plan benefits to get started. {{ plan?.planType }}
        </div>
        <div class="ac-plan-body">
          <span v-if="!isNonHardwarePlan"
            >*Smart sensors & installation will always be one of the options included in a plan. You
            may move its order placement, but not remove it.</span
          >
          <div v-if="isNonHardwarePlan">
            *<span class="pbi-info-text">Smart sensors & installation</span> will be always included
            in hardware-enabled plans. You may choose a non-hardware plan under Plan Pricing.
          </div>
        </div>
        <div v-if="isNonHardwarePlan" class="ac-plan-body margin-top-12">
          <span class="sac__font-12 bold">Please note:</span> Plans without hardware do not qualify
          for 24/7 monitoring or monthly system health reports.
        </div>
      </div>
      <button type="button" class="ac-button" @click="close">Cancel</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanBenefitInfo',
  props: {
    close: Function,
    plan: Object,
  },
  computed: {
    isNonHardwarePlan() {
      return this.plan?.planType !== 'Hardware';
    },
  },
};
</script>

<style lang="scss">
.pbi-info-text {
  color: $NBLUE100;
}
</style>
